export default __webpack_public_path__ + "static/media/character-hirokado.eb6987bc.png";